import React, { useState } from "react";
import { Drawer } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Typography,
  Avatar,
  IconButton,
  Button,
  CircularProgress,
} from "@mui/material";
import { IoMdClose } from "react-icons/io";
import CustomInput from "../../Common/CustomInput";
import ImageUploader from "../../Common/ImageUploader";
import { useMutation } from "@apollo/client";
import { CREATE_BANNER } from "../../../Utils/Mutation";
import Loader from "../../Common/Loader";
import { useSnackbarHook } from "../../../hooks/useSnackbarHook";
import { uploadSingleImageToCloudinary } from "../../../Utils/productEditHelpers";

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 540,
    flexShrink: 0,
    p: 4,
  },
  drawerPaper: {
    width: 540,
    p: 4,
  },
  toolbar: theme.mixins.toolbar,
}));

const TopBanner = ({ open, onClose, getAllBanner }) => {
  const classes = useStyles();
  const { handleClick } = useSnackbarHook();

  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [link, setLink] = useState("");
  const [isUploading, setIsUploading] = useState(false);

  const [createBanner, { loading }] = useMutation(CREATE_BANNER);

  const handleGetFile = async (nextFile) => {
    setFile(nextFile);

    if (!nextFile) {
      setImageUrl("");
      return;
    }

    setIsUploading(true);
    try {
      const uploadedUrl = await uploadSingleImageToCloudinary(nextFile);
      setImageUrl(uploadedUrl);
      handleClick("Image uploaded successfully", "success");
    } catch (error) {
      setFile(null);
      setImageUrl("");
      setFileUrl("");
      handleClick(error?.message || "Image upload failed", "error");
    } finally {
      setIsUploading(false);
    }
  };

  const handleGetUrl = (url) => {
    setFileUrl(url);
  };

  const handleCreateBanner = async () => {
    const type = "WEB_TOP";
    const route = link.trim();
    const description = "";

    if (!imageUrl) {
      handleClick("Please upload a banner image first", "warning");
      return;
    }

    

    try {
      await createBanner({
        variables: {
          imageUrl,
          type,
          route,
          description,
        },
      });

      getAllBanner?.();
      handleClick("Banner added successfully", "success");
      setFile(null);
      setFileUrl("");
      setImageUrl("");
      setLink("");
      onClose?.();
    } catch (error) {
      console.error("Error creating banner:", error);
      handleClick(error?.message || "Failed to create banner", "error");
    }
  };


    
  return (
    <Drawer
      className={classes.drawer}
      anchor="right"
      open={open}
      onClose={onClose}
      classes={{ paper: classes.drawerPaper }}
    >
      {(loading || isUploading) && <Loader />}
      <Box sx={{ px: 4, py: 5 }} className={classes.toolbar}>
        <Box align="right">
          <IconButton onClick={onClose}>
            <IoMdClose style={{ fontSize: "20px", color: "#000" }} />
          </IconButton>
        </Box>
        <Typography
          sx={{
            fontFamily: "Lato",
            color: "#0D0D0D",
            fontSize: "14px",
            fontWeight: 600,
            // ml: 5,
            mb: 3,
          }}
        >
          Add Top Banner
        </Typography>

        <Box sx={{ mt: 6 }}>
          <Box sx={{ mb: 2 }}>
            <ImageUploader
              placeholder="JPG, PNG or GIF, file size no more than 10MB 
 Image size of 1440 X 240"
              getFile={handleGetFile}
              url={handleGetUrl}
            />
            {file && (
              <Avatar
                src={fileUrl}
              
                sx={{ borderRadius: 1, width: "100%", height: "200px", my: 2, objectFit:'contain' }}
              />
            )}
            {isUploading && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                <CircularProgress size={16} />
                <Typography sx={{ fontSize: "12px", color: "#666" }}>
                  Uploading image...
                </Typography>
              </Box>
            )}
          </Box>
          <CustomInput
            label="Url Link"
            value={link}
            onChange={(e) => setLink(e.target.value)}
          />

          <Button
            onClick={handleCreateBanner}
            disabled={!imageUrl || isUploading || loading}
            variant="contained"
            fullWidth
            sx={{ mt: 4 , height:'50px'}}
          >
            Upload Banner
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};
export default TopBanner;
